module.exports = __webpack_public_path__ + "media/images/result_sets/icons/easy_icon_horiz-be24a7c4b46c090328ba3d394a9704ce.svg";